import logoWhite from "../../../design-system/assets/logos/nymbl-logo-white.png";
import { ThemeToggle } from "./ThemeToggle";

/**
 * The sign-in shell: a navy brand panel stating what the product does, beside
 * the form.
 *
 * The three figures along the bottom are the product's claim in the smallest
 * space it can be made — 25 scored sections, upload IS the run, hours become
 * minutes. They are static copy, not live metrics: this page renders before
 * anyone is authenticated, so it has no data to read and must not appear to.
 */
export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen">
      <div
        className="relative hidden overflow-hidden lg:flex lg:w-[54%] lg:flex-col lg:justify-between"
        style={{ background: "var(--bg-inverse)", padding: "60px 56px" }}
      >
        <img src={logoWhite} alt="Nymbl" className="relative z-10 h-[26px] w-auto self-start" />

        <div className="relative z-10">
          <div
            className="mb-5 text-[13px] font-semibold tracking-[0.14em] uppercase"
            style={{ color: "var(--brand-g-cyan)" }}
          >
            Solution Plan Audit
          </div>
          <h1 className="font-display max-w-[15ch] text-[44px] leading-[1.12] font-bold tracking-[-0.02em] text-white">
            Score a plan against the standard — not by hand.
          </h1>
          <p className="mt-[22px] max-w-[44ch] text-[17px] leading-[1.55] text-white/[0.66]">
            Every solution keeps its plan versions in one place. Audit any version against the
            Solution Plan Guide and see what was found, what the Guide asked for, and what to write
            instead.
          </p>
        </div>

        <div className="relative z-10 flex gap-10">
          {[
            ["25", "scored sections"],
            ["1 step", "upload is the run"],
            ["hours → min", "per audit"],
          ].map(([value, label]) => (
            <div key={label}>
              <div className="font-display text-[26px] font-bold text-white">{value}</div>
              <div className="text-xs text-white/50">{label}</div>
            </div>
          ))}
        </div>

        {/* Brand gradient bloom, echoing the logo mark. Decorative only. */}
        <div
          className="pointer-events-none absolute -right-[140px] -bottom-[160px] size-[460px] rounded-full opacity-[0.22] blur-[10px]"
          style={{ background: "var(--brand-gradient-45)" }}
          aria-hidden="true"
        />
      </div>

      <div className="flex w-full flex-col bg-white lg:w-[46%]">
        <div className="flex items-center justify-between p-4 lg:justify-end">
          <span className="font-display text-xl font-bold text-[var(--brand-primary)] lg:hidden">
            Nymbl Audit
          </span>
          <ThemeToggle />
        </div>

        <div className="flex flex-1 items-center justify-center px-4 pb-12">
          <div className="w-full max-w-md">{children}</div>
        </div>
      </div>
    </div>
  );
}
